<div class="container">
  <div class="panel">
    <div class="payment-wrapper">
      <h1 class="heading-primary">You have paid successfully!</h1>
      <p class="paragraph">You will automatically be redirected.</p>
      <div class="icon icon--bg-primary-light">
        <svg xmlns="http://www.w3.org/2000/svg" width="60" height="42" viewBox="0 0 60 42" fill="none">
          <path d="M57.5 2.25L19.6875 39.75L2.5 22.7045" stroke="#0A4793" stroke-width="4" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>
      <button class="btn btn-primary btn-block" (click)="redirectToMerchant()">Go back to
        {{merchantInfo?.beneficiaryName || 'merchant'}}</button>
    </div>
  </div>
</div>